import React from "react";
import { Buffer } from "buffer";

if (!window.Buffer) window.Buffer = Buffer;

const slugify = (s) =>
  String(s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60) || "venue";

/**
 * Render the lead-stats executive PDF and trigger a browser download.
 *
 * Dynamic-imports @react-pdf/renderer (matches generateCotizacionPDF.js) so
 * the ~300KB renderer doesn't ship in the initial bundle.
 */
export async function generateLeadStatsPDF({ venue, range, stats }) {
  const [{ pdf }, { default: LeadStatsPDF }] = await Promise.all([
    import("@react-pdf/renderer"),
    import("../components/LeadStatsPDF"),
  ]);

  const doc = React.createElement(LeadStatsPDF, { venue, range, stats });
  const blob = await pdf(doc).toBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `estadisticas_leads_${slugify(venue?.name)}_${range?.key || "rango"}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
